import payline from "../assets/paylines/payline.png";

export default function Paylines({ text }) {
  return (
    <div className="wrapper">
      <div className="content">
        <div className="title">{text[0].title}</div>
        <div className="description">{text[0].desc}</div>
      </div>
      <div className="img_box">
        <img src={payline} alt="paylines" />
      </div>
    </div>
  );
}
